// extracted by mini-css-extract-plugin
export default {"controls":"BottomControls_controls__xl8jx"};